function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridCardComponent from '@/components/work_environments/GridCardComponent';
import { mapState } from 'vuex';
import { ROLES_LIST } from '@/js/constants';
var INTERBANK_COMPANY_CODE = '000';
export default {
  name: 'OverviewPage',
  components: {
    GridCardComponent: GridCardComponent
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('frases.attrs_overview_message'),
        disabled: true
      }];
    },
    isInterbankProfile: function isInterbankProfile() {
      var code = this.companyCode === null || this.companyCode === undefined ? '' : String(this.companyCode).trim();
      var isInterbankCode = !!code && code.padStart(3, '0') === INTERBANK_COMPANY_CODE;
      return isInterbankCode || String(this.companyName || '').toLowerCase() === 'interbank';
    },
    canShowCreateAttribute: function canShowCreateAttribute() {
      var userInfo = window.userInfo || {};
      var roles = userInfo.userRoles || [];
      var email = (userInfo.email || '').toLowerCase();
      var domain = (userInfo.domain || '').toLowerCase();
      var isIntercorpProfile = email.endsWith('@intercorp.com.pe') || domain === 'intercorp.com.pe';
      var hasValidRole = roles.includes(ROLES_LIST.ATTRIBUTE_ADMIN) || roles.includes(ROLES_LIST.ATTRIBUTE_USER);
      return hasValidRole && (isIntercorpProfile || this.isInterbankProfile);
    },
    cards: function cards() {
      var baseCards = [{
        title_es: 'Búsqueda de atributos',
        title_en: 'Attribute search',
        color: '#F1F1F1',
        image: 'Search.png',
        flex: 4,
        path: '/attributes/search',
        access: true
      }, {
        title_es: 'Crear Sandbox',
        title_en: 'Create Sandbox',
        color: '#F1F1F1',
        image: 'Request.png',
        flex: 4,
        path: '/attributes/selected',
        access: true
      }, {
        title_es: 'Mis Sandboxes',
        title_en: 'My Sandboxes',
        color: '#F1F1F1',
        image: 'MyUseCase.png',
        flex: 4,
        path: '/attributes/use_cases/history',
        access: true
      }, {
        title_es: 'Subir mi data',
        title_en: 'Upload My Data',
        color: '#F1F1F1',
        image: 'UploadData.png',
        flex: 4,
        path: '',
        access: true
      }, {
        title_es: 'Productivizar mi caso',
        title_en: 'Productize my case',
        color: '#F1F1F1',
        image: 'Model.png',
        flex: 4,
        path: '/attributes/use_cases/productize_model',
        access: true
      }];
      if (this.canShowCreateAttribute) {
        baseCards.splice(5, 0, {
          title_es: 'Crear atributo',
          title_en: 'Create Attribute',
          color: '#F1F1F1',
          image: 'Model.png',
          flex: 4,
          path: '/attributes/use_cases/create_attribute',
          access: true
        });
      }
      baseCards.push({
        title_es: 'Casos de negocio',
        title_en: 'Business Cases',
        color: '#F1F1F1',
        image: 'UseCase.png',
        flex: 4,
        path: '',
        access: true
      });
      return baseCards;
    }
  })
};